export const notificationDetailsConfig = [
    {
        id: 1,
        title: "Title",
        key: "title",
        value: "",
    },
    {
        id: 2,
        title: "Schedule Date",
        key: "scheduleDate",
        value: "",
    },
    {
        id: 3,
        title: "Schedule Time",
        key: "scheduleTime",
        value: "",
    },
    {
        id: 4,
        title: "Status",
        key: "status",
        value: "",
    },
];
